import { render, staticRenderFns } from "./VueNode.vue?vue&type=template&id=0f2bc7fe&scoped=true&"
import script from "./VueNode.vue?vue&type=script&lang=js&"
export * from "./VueNode.vue?vue&type=script&lang=js&"
import style0 from "./VueNode.vue?vue&type=style&index=0&id=0f2bc7fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2bc7fe",
  null
  
)

export default component.exports